/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  query MyQuery($name: String) {
    AvailableCategoryName(name: $name) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
